import React, { Component } from "react";
import { Card, Col, Row, Form, Table } from "react-bootstrap-v5";
import "react-bootstrap-typeahead/css/Typeahead.css";
// import { toast } from "react-toastify";
import moment from "moment";
// import { MdDeleteForever, MdEdit, MdVisibility } from "react-icons/md"

import JobService from "../../Services/JobService";
import { revenuecostService } from "../../Services/revenuecostService";
import ReactPaginate from "react-paginate";
import Loader from "../../Components/Loader";
let currentPage1 = 1;

class JobListRetailer extends Component {
  state = {
    jobList: [],
    retailers: [],
    loader: true,
    pagination: { page: 1, limit: 10, totalRecord: 0 },
    currentPage: currentPage1,
  };

  componentDidMount() {
    this.getJobList();
    this.getRetailer();
    this.signInIntuit();
  }

  getJobList = (search = "") => {
    const { pagination, currentPage } = this.state;
    let param = {
      limit: pagination.limit,
      page: currentPage,
      search: search,
    };

    JobService.getPayRetailerJobs(param).then((result) => {
      if (result.status === true) {
        this.setState({
          jobList: result.data,
          pagination: {
            ...pagination,
            totalRecord: result.pagination.totalRecord,
          },
          loader: false,
        });
      } else {
        this.setState({ loader: false });
      }
    });
  };

  getRetailer = () => {
    let param = {};
    param["limit"] = 1000;
    param["page"] = 1;

    JobService.getRetailers(param).then((result) => {
      if (result.status === true) {
        this.setState({
          retailers: result.data,
        });
      }
    });
  };

  signInIntuit = () => {
    // var win;
    // var parameters = "location=1,width=800,height=650";
    // parameters += ",left=" + (window.innerWidth - 800) / 2 + ",top=" + (window.innerHeight - 650) / 2;

    revenuecostService.qbookAuth().then((result) => {
      // Launch Popup
      // win = window.open(result, 'connectPopup', parameters);
      // this.props.history.push(result)
      if (!result.status) {
        localStorage.setItem("redirectUri", window.location.href);
        window.location.href = result.uri;
      }
    });
  };

  handleOnChange = (e) => {
    const { name, checked } = e.target;
    const { jobList } = this.state;

    if (name === "allSelect") {
      let temJobList = jobList.map((item) => {
        return { ...item, isChecked: checked };
      });
      this.setState({ jobList: temJobList });
    } else {
      let temJobList = jobList.map((item) =>
        item.jobToken === name ? { ...item, isChecked: checked } : item
      );
      this.setState({ jobList: temJobList });
    }
  };

  handleSelect = async (e, jobId = "", index = "") => {
    const { value } = e.target;
    const { jobList } = this.state;

    let param = [];

    if (jobId === "") {
      param = jobList.map((item) => {
        return {
          jobId: item._id,
          retailerId: item.retailerInfo[0].retailer_id,
          invoicePayoutStatus: value,
        };
      });
    } else {
      param = [
        {
          jobId: jobList[index]._id,
          retailerId: jobList[index].retailerInfo[0].retailer_id,
          invoicePayoutStatus: value,
        },
      ];
    }

    await JobService.updateRetailerPayStatus(param).then((result) => {
      if (result.status === true) {
        this.setState({ retailers: result.data });
      }
    });
  };

  onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    this.setState({ loader: true, currentPage: e.selected + 1 }, () => {
      this.getJobList();
    });
  };

  render() {
    const { jobList, retailers, loader, pagination, currentPage } = this.state;

    return (
      <Card>
        <Card.Body>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Select onChange={(e) => this.getJobList(e.target.value)}>
                <option value="">Select Retailer</option>
                {retailers.length > 0 &&
                  retailers.map((item) => (
                    <option value={item.retailer_name}>
                      {item.retailer_name}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            <Col md={3}>
              <Form.Select onChange={(e) => this.handleSelect(e)}>
                <option value="">Pay Status</option>
                <option value="paid">Paid</option>
                <option value="unpaid">Unpaid</option>
              </Form.Select>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>
                      <Form.Check
                        type="checkbox"
                        name="allSelect"
                        onChange={(e) => this.handleOnChange(e)}
                        checked={
                          jobList.filter((item) => item?.isChecked !== true)
                            .length < 1
                        }
                      />
                    </th>
                    <th>S.No</th>
                    <th>Job Id</th>
                    <th>Customer Name</th>
                    <th>Retailer Name</th>
                    <th>Actual Amount</th>
                    <th>Date</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  {jobList.map((item, index) => {
                    return (
                      <tr key={item.jobToken}>
                        <td>
                          <Form.Check
                            type="checkbox"
                            name={item.jobToken}
                            id={`job-${item.jobToken}`}
                            value={item.jobToken}
                            checked={item?.isChecked || false}
                            onChange={(e) => this.handleOnChange(e)}
                          />
                        </td>
                        {/* <td>{index + 1}</td> */}
                        <td className="text-body fw-bold">
                          {(currentPage - 1) * pagination.limit + (index + 1)}
                        </td>
                        <td>{item.jobToken}</td>
                        <td>{item.custName}</td>
                        <td>{item.retailerInfo[0].retailer_name}</td>
                        <td>{item.payInfo.actual_amount}</td>
                        <td>{moment(item.dateAt).format("YYYY-MM-DD")}</td>
                        <td>
                          <Form.Select
                            name="singlePay"
                            onChange={(e) =>
                              this.handleSelect(e, item._id, index)
                            }
                          >
                            <option value="">Pay Status</option>
                            <option value="paid">Paid</option>
                            <option value="unpaid">Unpaid</option>
                          </Form.Select>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              {jobList.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="prev"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="next"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={this.onPageChangeEvent}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
              <Loader isShow={loader} />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export { JobListRetailer };
